import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { StoreState } from '../../models/store.interface';

import { CommunicationPreferenceType } from '@nxtpeople/nxt-styles';
import { CommunicationPreferenceTypeService } from './communication-preference-type.service';

const service = new CommunicationPreferenceTypeService();

export interface CommunicationPreferenceTypeState {
   communicationPreferenceTypes: Array<CommunicationPreferenceType>;
}

const CommunicationPreferenceTypeStore: Module<CommunicationPreferenceTypeState, StoreState> = {
   namespaced: true,
   state: { communicationPreferenceTypes: [] },
   getters: {
      communicationPreferenceTypes: (state) => state.communicationPreferenceTypes,
   },
   mutations: {
      SET_COMMUNICATION_PREFERENCE_TYPES(state, communicationPreferenceTypes: Array<CommunicationPreferenceType>) {
         state.communicationPreferenceTypes = communicationPreferenceTypes;
      },
   },
   actions: {
      async getCommunicationPreferenceTypes(context, query: LocationQuery) {
         const response = await service.getCommunicationPreferenceTypes({ ...query, per_page: '9999', page: '1' });
         context.commit('SET_COMMUNICATION_PREFERENCE_TYPES', response.data);
         return response;
      },
   },
};

export default CommunicationPreferenceTypeStore;
